if (process.env.NODE_ENV === "development" && typeof window !== "undefined") {
  if ("serviceWorker" in navigator) {
    void navigator.serviceWorker
      .getRegistrations()
      .then((registrations) =>
        Promise.all(
          registrations.map((registration) => registration.unregister())
        )
      )
      .catch(() => {});
  }

  if ("caches" in window) {
    void caches
      .keys()
      .then((cacheNames) =>
        Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)))
      )
      .catch(() => {});
  }
}

import("./boostrap");

export {};
